export default __webpack_public_path__ + "static/media/TOMTOM.5ce24f2c.png";